import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { ChatMobileComponent } from './chat-mobile.component';

@Injectable({ providedIn: 'root' })
export class ChatMobileUploadGuard implements CanDeactivate<ChatMobileComponent> {
  canDeactivate(component: ChatMobileComponent): boolean {
    return component.canDeactivate();
  }
}
